// constants/avatars.js
const AVATARS = [
    { id: "default", file: "default.webp", label: "Default" },
    { id: "aislinn", file: "aislinn.webp", label: "Aislinn" },
    { id: "arbaal", file: "arbaal.webp", label: "Arbaal" },
    { id: "astragoth", file: "astragoth.webp", label: "Astragoth" },
    { id: "azazel", file: "azazel.webp", label: "Azazel" },
    { id: "belakor", file: "belakor.webp", label: "Belakor" },
    { id: "boris", file: "boris.webp", label: "Boris" },
    { id: "changeling", file: "changeling.webp", label: "Changeling" },
    { id: "daniel", file: "daniel.webp", label: "Daniel" },
    { id: "dechala", file: "dechala.webp", label: "Dechala" },
    { id: "drazhoath", file: "drazhoath.webp", label: "Drazhoath" },
    { id: "elspeth", file: "elspeth.webp", label: "Elspeth" },
    { id: "epidemius", file: "epidemius.webp", label: "Epidemius" },
    { id: "festus", file: "festus.webp", label: "Festus" },
    { id: "golgfag", file: "golgfag.webp", label: "Golgfag" },
    { id: "gorbad", file: "gorbad.webp", label: "Gorbad" },
    { id: "greasus", file: "greasus.webp", label: "Greasus" },
    { id: "kairos", file: "kairos.webp", label: "Kairos" },
    { id: "kostaltyn", file: "kostaltyn.webp", label: "Kostaltyn" },
    { id: "kugath", file: "kugath.webp", label: "Kugath" },
    { id: "malakai", file: "malakai.webp", label: "Malakai" },
    { id: "masque", file: "masque.webp", label: "Masque" },
    { id: "miao_ying", file: "miao_ying.webp", label: "Miao Ying" },
    { id: "nkari", file: "nkari.webp", label: "Nkari" },
    { id: "ostankya", file: "ostankya.webp", label: "Ostankya" },
    { id: "sayl", file: "sayl.webp", label: "Sayl" },
    { id: "skarbrand", file: "skarbrand.webp", label: "Skarbrand" },
    { id: "skrag", file: "skrag.webp", label: "Skrag" },
    { id: "skulltaker", file: "skulltaker.webp", label: "Skulltaker" },
    { id: "tamurkhan", file: "tamurkhan.webp", label: "Tamurkhan" },
    { id: "tzarina", file: "tzarina.webp", label: "Tzarina" },
    { id: "valkia", file: "valkia.webp", label: "Valkia" },
    { id: "vilitch", file: "vilitch.webp", label: "Vilitch" },
    { id: "yuan_bo", file: "yuan_bo.webp", label: "Yuan Bo" },
    { id: "zhao_ming", file: "zhao_ming.webp", label: "Zhao Ming" },
    { id: "zhatan", file: "zhatan.webp", label: "Zhatan" }
];

const DEFAULT_AVATAR = "/avatars/default.webp";

export function getAvatarUrl(avatarUrl) {
    // Default
    if (!avatarUrl || avatarUrl.trim() === "") return DEFAULT_AVATAR;

    // Already a full URL or absolute path
    if (avatarUrl.startsWith("http") || avatarUrl.startsWith("/")) return avatarUrl;

    // Verify it's a known avatar file, otherwise fall back to default
    const known = AVATARS.some((a) => a.file === avatarUrl);
    if (!known) return DEFAULT_AVATAR;

    return `/avatars/${avatarUrl}`;
}

export default AVATARS;